import type { OnboardingPromptDefinition } from "./types";

export const ONBOARDING_PROMPT_REGISTRY: OnboardingPromptDefinition[] = [
  {
    id: "homepageTour",
    priority: 100,
    isEligible: (ctx) => {
      if (ctx.isAuthLoading || ctx.pathname !== "/") return false;
      if (ctx.isAuthenticated) return !ctx.flags.homepageAutoshowDone;
      return !ctx.flags.guestHomepageAutoshowDone;
    },
  },
  {
    id: "sellIntro",
    priority: 80,
    isEligible: (ctx) =>
      !ctx.isAuthLoading &&
      ctx.isAuthenticated &&
      ctx.pathname === "/sell" &&
      !ctx.flags.sellPreformDone,
  },
  {
    id: "myItemsStatusIntro",
    priority: 70,
    isEligible: (ctx) =>
      !ctx.isAuthLoading &&
      ctx.isAuthenticated &&
      ctx.pathname === "/my-items" &&
      !ctx.flags.myItemsStatusModalDone,
  },
  {
    id: "marketIntro",
    priority: 60,
    isEligible: (ctx) =>
      !ctx.isAuthLoading &&
      ctx.isAuthenticated &&
      ctx.pathname === "/market" &&
      !ctx.flags.marketIntroDone,
  },
];
